<div class="xy-container column-expand">
  <div class="user-header">
    <div>
      <h4>Ciao {{ credentialsService.credentials?.first_name }}!</h4>
      <ng-container *ngIf="surveyCompleted$ | async as surveyCompleted">
        <p>
          <span>Hai risposto a</span>
          <span>&nbsp;</span>
          <strong>{{ surveyCompleted?.length }} sondaggi</strong>
          <span>&nbsp;</span>
          <span>: rispondi ai questionari proposti da Pollstar, accumula punti e ricevi sempre nuovi premi!</span>
        </p>
      </ng-container>
    </div>

    <div>
      <img src="/assets/pollstar_logo_notext.svg" alt="pollstar_logo" class="pollstar_logo">
      <button
        mat-flat-button
        class="btn btn-pollstar btn-pollstar-tiny btn-gradient-orange"
        [ngClass]="{ 'disabled btn-warning' : isSyncInProgress$ | async }"
        [disabled]="!!(isSyncInProgress$ | async)"
        (click)="refreshAll()"
      >
        <span style="font-size: 1rem;">{{ (isSyncInProgress$ | async) ? 'Aggiornamento' : 'Aggiorna' }}</span>
      </button>
    </div>

  </div>

  <div class="user-detail-container">
    <div class="survey-summary">
      <mat-card
        class="participant-surveys mat-card--mobile-flat"
        [ngClass]="{ 'hasNotCompletedInitialSurvey' : !(hasCompletedInitialSurvey$ | async) || (isSyncInProgress$ | async)}"
      >
        <div *ngIf="surveys$ | async as surveys">
          <div class="column-expand">
            <span class="title-3">Elenco dei sondaggi</span>
            <p>{{ surveys?.length }} Sondaggi totali</p>
          </div>
          <br>
        </div>
        <mat-card-content style="padding:0;">
          <app-user-survey-table></app-user-survey-table>
        </mat-card-content>
      </mat-card>
    </div>


    <div class="column-expand">
      <mat-card class="participant-points">
        <div class="column-expand">
          <span class="title-3">I tuoi dettagli</span>
        </div>
        <ng-container [ngSwitch]="!(isSyncInProgress$ | async)" >

          <ng-container *ngSwitchCase="true" >
            <ng-container *ngIf="point$ | async as points">
              <mat-card-content style="padding:0;">
                <p><strong>Punti ottenuti</strong>&nbsp;{{ points.earned }}</p>
                <p><strong>Punti usati</strong>&nbsp;{{ points.used }}</p>
              </mat-card-content>
              <mat-divider></mat-divider>
              <mat-card-footer style="padding:1rem;">
                <p><strong>Punti totali</strong>&nbsp;{{ points.balance }}</p>
              </mat-card-footer>
            </ng-container>
          </ng-container>

          <div *ngSwitchDefault>
            <app-card-overlay title="Aggiornamento dettaglio punti" size="small"></app-card-overlay>
          </div>
        </ng-container>
      </mat-card>

      <mat-card class="participant-details">
          <mat-card-content>
            <app-participant-detail-card [participantID]="participantID"></app-participant-detail-card>
          </mat-card-content>
      </mat-card>

    </div>
  </div>
</div>
